import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../../styles/AppTheme';
import TableCell from '@material-ui/core/TableCell';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

export class TableNumComponentRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value ? this.props.value : 0 //TODO: why zero?
    }
  }

  change = e => {

    if (e.target.value === this.state.value) {
      this.setState({
        value: null
      })
      this.props.handleState(e.target.name, null)
    } else {
      this.setState({
        value: e.target.value
      })
      this.props.handleState(e.target.name, e.target.value)
    }
  }

  render() {
    const thisObj = this //TODO
    return (
      <RadioGroup
        name={this.props.id}
        value={this.state.value}
        className={css(Styles.radioGroup)}>
        {
          Object.keys(this.props.options).sort(function (a, b) { return (Number(thisObj.props.options[a].order) - Number(thisObj.props.options[b].order)) })
            .map((item,index) => {
              return (
                <TableCell className={css(Styles.tableCell)} key={index}>
                  <FormControlLabel
                    value={String(this.props.options[item].id)}
                    control={
                      <Radio
                        onClick={e => this.change(e)}
                        color='secondary'
                        checkedIcon={
                          <div className={css(Styles.radioIcon)}>
                            <div className={css(Styles.radioCheckedIcon)} />
                          </div>
                        }
                        icon={
                          <div className={css(Styles.radioIcon)} />
                        }
                      />}
                    key={this.props.options[item].id}
                  />
                </TableCell>
              )
            })
        }
      </RadioGroup>
    );
  }
}

const Styles = StyleSheet.create({
  radioIcon: {
    width: 25,
    height: 25,
    background: AppTheme.secondaryBg + '0% 0% no-repeat padding-box',
    border: '3px solid' + AppTheme.borderColor,
    zIndex: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  radioCheckedIcon: {
    width: 19,
    height: 19,
    borderRadius: '50%',
    backgroundColor: AppTheme.selectedColor
  },
  tableCell: {
    textAlign: 'center'
  },
  radioGroup: {
    display: 'contents'
  },
})


// WEBPACK FOOTER //
// ./src/components/quizzing/TableNum/TableNumComponentRadio.js